<template>
  <b-col sm="12" :lg="lgSize">
    <div class="animated fadeIn">
      <b-card  class="backClass" style="height:450px"  header="Received">
        <div slot="header">
          <h5 style="display: inline;" class="card-title mb-0">Delivered By FNS</h5>
          <div class="card-header-actions">
                <b-input-group size="sm">
                  <b-form-input
                    v-model="filter"
                    type="search"
                    id="filterInput"
                    placeholder="Type to Search"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                  </b-input-group-append>
                </b-input-group>
          </div>
        </div>
        <div class>
          <div style="height: 400px; padding-top: 150px" v-if="loadingData" class="loading">
            <b-row>
              <b-col lg="12">
                <div class="sk-double-bounce">
                  <div class="sk-child sk-double-bounce1"></div>
                  <div class="sk-child sk-double-bounce2"></div>
                </div>
              </b-col>
            </b-row>
          </div>
          <div v-else>

            <!--<c-table :table-data="items" :fields="fields" :caption="title"></c-table>-->
            <b-table responsive style="height:350px" :filter="filter" :fields="fields" size="lg" :items="items">
              <template v-slot:cell(user)="{ value }">
                <img :src="value" width="40px" style="border-radius: 100px;" />
              </template>
              <!--<template v-slot:cell(image)="{ item, value }">-->
              <!--<b-link :href="value">{{ item.image /* === value */ }}</b-link>-->
              <!--</template>-->
              <template v-slot:cell(image)="row">
                <b-button size="sm" @click="info(row.item, row.index, $event.target)" class="mr-1">
                  <i class="fa fa-photo" aria-hidden="true"></i>
                </b-button>
                <a :href="row.item.image" download>
                  <b-button size="sm" class="mr-1">
                    <i class="fa fa-download" aria-hidden="true"></i>
                  </b-button>
                </a>
              </template>
            </b-table>
          </div>
        </div>
        <b-modal :id="infoModal.id" :title="infoModal.title" ok-only @hide="resetInfoModal">
          <img :src="infoModal.content" width="100%" />
        </b-modal>
      </b-card>
    </div>
  </b-col>
</template>

<script>
import { Chart } from "highcharts-vue";
import router from "../router";
import Datepicker from "vuejs-datepicker";
import cTable from "../../src/views/base/Table";

export default {
  name: "ActiveBacklog-Column",
  components: {
    router,
    cTable,
    highcharts: Chart,
    Datepicker
  },
  props: ["lgSize", "lgOffset", "locParam", "idCity", "nameCity"],
  data: function() {
    return {
      filter: null,
      fullscreen: false,
      loadingData: false,
      showAll: false,
      modalDate: false,
      dateFrom: "",
      dateTo: "",
      city: "",
      locationName: "",
      productGroup: "",
      locationsIds: "",
      title: "",
      items: [],
      fields: [
        { key: "user", label: "Driver" },
        { key: "fullName", label: "" },
        { key: "deliveryDate", label: "Date Of Delivery" },
        { key: "ranum", label: "RMA" },
        { key: "location", label: "Location" },
        { key: "contact", label: "Contact" },
        { key: "InvoiceNo", label: "#InvoiceNo" },
        { key: "InvoiceDate", label: "#Invoice Date" },
        { key: "image", label: "Image" }
      ],
      infoModal: {
        id: "info-modal",
        title: "",
        content: ""
      }
    };
  },
  methods: {
    info(item, index, button) {
      this.infoModal.title = `RMA: ${item.ranum}`;
      this.infoModal.content = item.image;
      this.$root.$emit("bv::show::modal", this.infoModal.id, button);
    },
    resetInfoModal() {
      this.infoModal.title = "";
      this.infoModal.content = "";
    },
    fetchData() {
      this.loadingData = true;
      let params = {};
      params = {
        clients: this.locationsIds
      };
      this.$http
        .get("api/tables/delivery_total.php", {
          params
        })
        .then(
          res => {
            this.loadingData = false;
            this.title = "Total records: " + res.data.count;
            this.items = res.data.records;
          },
          err => {
            this.loadingData = false;
            console.log(err);
          }
        );
    }
  },
  computed: {
    from() {
      if (typeof this.dateFrom === "object") {
        this.dateFrom = this.dateFrom.toISOString().split("T")[0];
        return this.dateFrom;
      }
    },
    to() {
      if (typeof this.dateTo === "object") {
        this.dateTo = this.dateTo.toISOString().split("T")[0];
        return this.dateTo;
      }
    }
  },
  mounted() {
    if (!localStorage.getItem("aoi_user")) {
      router.push("/pages/login/");
    }
    this.locationsIds = localStorage.getItem("locations");
    this.fetchData();
  }
};
</script>

<style>
/* IE fix */
#card-chart-01,
#card-chart-02 {
  width: 100% !important;
}
.vdp-datepicker__calendar {
  position: absolute !important;
  z-index: 100;
  background: #3a4149 !important;
  width: 300px;
  border: 1px solid #ccc;
}
.form-control:disabled,
.form-control[readonly] {
  background-color: #515b65 !important;
  opacity: 1 !important;
}
</style>
